import React from 'react';
import { useTranslation } from 'react-i18next';

import { ControlModeEnum } from '@/constants/enums';
import ConditionalToolTip from '@/utils/ConditionalTooltip';
import {
  getKeyFromMap,
  getStatusAndShape,
  GetConnectivityParams,
  controllableMap,
  onOffMap,
  ControlTypesMapping,
  StatusAndShape,
} from './GetConnectivityIconAndStatus.utils';
import { ConnectivityIconWrapper } from './GetConnectivityIconAndStatus.styles';

const GetConnectivityIconAndStatus = (params: GetConnectivityParams) => {
  const { connectivity, activity, controlMode, extendedActivity, shouldHideTooltip } = params;
  const { t } = useTranslation();
  let statusAndShape: StatusAndShape = { status: '', shape: null };
  let shouldShowTooltip = true;
  let relevantConnectivityMap;
  let result;

  switch (controlMode) {
    case ControlModeEnum.Controllable:
    case ControlModeEnum.NotControllable:
      relevantConnectivityMap = getKeyFromMap(controllableMap, connectivity);
      result =
        (getKeyFromMap(relevantConnectivityMap, extendedActivity) as ControlTypesMapping) ??
        (getKeyFromMap(relevantConnectivityMap, activity) as ControlTypesMapping);
      statusAndShape = getStatusAndShape(result, t);
      break;
    case ControlModeEnum.OnOff:
      statusAndShape = getStatusAndShape(onOffMap, t);
      shouldShowTooltip = false;
      break;
  }

  const { shape, status } = statusAndShape;

  return {
    icon: (
      <ConditionalToolTip condition={shouldShowTooltip && !shouldHideTooltip} content={status}>
        <ConnectivityIconWrapper size={params.size}>{shape}</ConnectivityIconWrapper>
      </ConditionalToolTip>
    ),
    status: status,
  };
};

export default GetConnectivityIconAndStatus;
